export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/calendar.c625ea6e.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};